import { Button } from "@/components/ui/button";
import type { ReportView } from "@/types/crm";

interface ReportViewBannerProps {
  view: ReportView;
  onSave: (name: string) => Promise<void>;
  onClear: () => void;
}

export function ReportViewBanner({
  view,
  onSave,
  onClear,
}: ReportViewBannerProps) {
  const hours = view.expiresAt
    ? Math.max(
        1,
        Math.ceil(
          (new Date(view.expiresAt).getTime() - Date.now()) / 3_600_000,
        ),
      )
    : 0;

  return (
    <div
      data-testid="report-view-banner"
      className="flex flex-wrap items-center justify-between gap-2 rounded-md border bg-muted/40 px-3 py-2 text-sm"
    >
      <span>Widok tymczasowy — wygaśnie za {hours} h</span>
      <div className="flex gap-2">
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => {
            const name = window.prompt("Nazwa widoku", view.name ?? "Mój widok");
            if (name) void onSave(name);
          }}
        >
          Zapisz widok
        </Button>
        <Button type="button" size="sm" variant="ghost" onClick={onClear}>
          Wyczyść
        </Button>
      </div>
    </div>
  );
}
